module.exports = __webpack_public_path__ + "static/media/check.46a5cd88.png";